module.exports = __webpack_public_path__ + "static/img/P2.42a257d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qdzy/P2.png
// module id = FmW8
// module chunks = 0